function amountInCents(value) {
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  if (typeof value === 'string' && !value.trim()) return null;
  const amount = Number(value);
  const cents = Math.round(amount * 100);
  return Number.isFinite(amount) && amount >= 0 && Number.isSafeInteger(cents) ? cents : null;
}

export function summarizeVoteRecord(record) {
  const bets = record && Array.isArray(record.data) ? record.data : [];
  const settledBets = bets.filter(bet => bet && Number(bet.status) === 1 &&
    (Number(bet.is_win) === 1 || Number(bet.is_win) === 2));
  const settled = bets.length > 0 && settledBets.length === bets.length;
  const started = bets.some(bet => bet && Number(bet.status) === 1);
  const summary = {
    settled,
    statusKey: settled ? 'reservation.drawn' : started ? 'reservation.settling' : 'reservation.to_be_drawn',
    profit: null,
    outcome: null
  };
  if (!settled) return summary;

  let profitCents = 0;
  for (const bet of bets) {
    const stake = amountInCents(bet.money);
    // The API's profit is the full payout for wins, but the lost stake for losses.
    // Never interpret its sign (or the period's total stake) as a win/loss flag.
    const payout = Number(bet.is_win) === 1 ? amountInCents(bet.profit) : 0;
    if (stake === null || payout === null) return summary;
    profitCents += payout - stake;
    if (!Number.isSafeInteger(profitCents)) return summary;
  }
  summary.profit = profitCents / 100;
  summary.outcome = profitCents > 0 ? 'win' : profitCents < 0 ? 'lose' : 'break_even';
  return summary;
}
